import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";

const BusinessAuthContext = createContext(null);

export const BusinessAuthProvider = ({ children }) => {
  const [businessUser, setBusinessUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/auth/business-session`,
          { withCredentials: true }
        );
        if (isMounted && res.data?.success) {
          setBusinessUser(res.data.business);
        }
      } catch (_) {
        // no business session
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const loginBusiness = async (external_business_id, business_type) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/auth/business-login`,
      { external_business_id, business_type },
      { withCredentials: true }
    );
    if (res.data?.success) {
      setBusinessUser(res.data);
      return res.data;
    }
    throw new Error(res.data?.message || "Business login failed");
  };

  const logoutBusiness = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/auth/business-logout`,
        {},
        { withCredentials: true }
      );
    } catch (_) {
      // ignore
    } finally {
      setBusinessUser(null);
    }
  };

  const value = useMemo(
    () => ({
      businessUser,
      setBusinessUser,
      loading,
      loginBusiness,
      logoutBusiness,
    }),
    [businessUser, loading]
  );

  return (
    <BusinessAuthContext.Provider value={value}>
      {children}
    </BusinessAuthContext.Provider>
  );
};

export const useBusinessAuth = () => useContext(BusinessAuthContext);
